import React from 'react';
import { ModalPopup } from '../../../CommonComponent';
import { Iprops } from './branchdetailsInterface';
import { RESOURCE } from "../../../../const/resource";
import { useTranslation } from "react-i18next"; import './branchdetails.scss';
import Loader from '../../../Loader';
import { selectors as headerSelector } from "../../../../state/features/header"; 
import { useSelector } from "react-redux";
import NoImage from '../../../../assets/images/NoImage.png';

const BranchDetails = (props: Iprops) => {
    const { t } = useTranslation();
    const branchData = props?.fullfilmentBranchInfo?.data;
    const { imgBaseUrlSelectors }: any = useSelector((state) => ({
        imgBaseUrlSelectors: headerSelector.imgbaseUrl(state),
    }));
    const fullAddress =  branchData?.fullAddress ? branchData?.fullAddress.replace(/\s+/g, ' ').trim() : '';

    return (
        <ModalPopup
            ModalPopupTitle=""
            ModalPopupType="medium"
            closeModalPopup={() => (props.onhandleClose())}>
            <div className='branchDetails-wrapper'>
                {props?.fullfilmentBranchInfo?.loading && <Loader />}
                <div className='branchDetailsHeading mb-2'>
                    {`${t(RESOURCE.MyK_Label_ShoppingCart_Dealer_Name)} - ${branchData?.distributorDisplayName}`}
                </div>
                <div className='branchAddress' title={fullAddress}>
                    {fullAddress}
                </div>
                <div className='DealerLogo mt-3 mb-3'>
                    {branchData?.imagePath ? <img src={branchData?.imagePath ?? ''} onError={(e: any) => {
                        if (e.currentTarget.src != imgBaseUrlSelectors + NoImage) {
                            e.currentTarget.src = imgBaseUrlSelectors + NoImage
                        }
                    }} alt="img" /> : null}
                </div>
                <div className='row delarDetails'>
                    <div className='col-lg-4'>
                        <div className='label'>
                            {t(RESOURCE.MyK_Label_ShoppingCart_Phone)}
                        </div>
                        <div className='value' title={branchData?.phone ?? ''}>
                            {branchData?.phone ?? '-'}
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='label'>
                            {t(RESOURCE.MyK_Label_ShoppingCart_Email)}
                        </div>
                        <div className='value' title={branchData?.dealerEmail ?? ''}>
                            {branchData?.dealerEmail ?? '-'}
                        </div>
                    </div>
                </div>
            </div>
        </ModalPopup>
    );
};

export default BranchDetails;